import React from 'react';

import classNames from 'classnames';

export interface ICardProps {
    children: React.ReactNode;
    className?: string;
    borderColor?: 'green' | 'grey'
}

export const Card = (props: ICardProps): JSX.Element => {
    const borderClassName: string = props.borderColor !== undefined ? `card__border_${props.borderColor}` : 'card__border_grey';
    const className: string = classNames('card', props.className, borderClassName);

    return (
        <div className={className}>
            {props.children}
        </div>
    );
};
